module.exports = __webpack_public_path__ + "img/Frame 715.70434945.png";